var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.28906 9.57143C7.28906 8.15127 8.44033 7 9.86049 7H13.7176C15.1378 7 16.2891 8.15127 16.2891 9.57143V13.4286C16.2891 14.8487 15.1378 16 13.7176 16H9.86049C8.44033 16 7.28906 14.8487 7.28906 13.4286V9.57143ZM9.86049 8.71429H13.7176C14.191 8.71429 14.5748 9.09804 14.5748 9.57143V13.4286C14.5748 13.902 14.191 14.2857 13.7176 14.2857H9.86049C9.38711 14.2857 9.00335 13.902 9.00335 13.4286V9.57143C9.00335 9.09804 9.38711 8.71429 9.86049 8.71429Z",
    fill: "#0E0F10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.28906 24.5714C7.28906 23.1513 8.44033 22 9.86049 22H13.7176C15.1378 22 16.2891 23.1513 16.2891 24.5714V28.4286C16.2891 29.8487 15.1378 31 13.7176 31H9.86049C8.44033 31 7.28906 29.8487 7.28906 28.4286V24.5714ZM9.86049 23.7143H13.7176C14.191 23.7143 14.5748 24.098 14.5748 24.5714V28.4286C14.5748 28.902 14.191 29.2857 13.7176 29.2857H9.86049C9.3871 29.2857 9.00335 28.902 9.00335 28.4286V24.5714C9.00335 24.098 9.3871 23.7143 9.86049 23.7143Z",
    fill: "#0E0F10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4319 9.57143C18.4319 9.09804 18.8157 8.71429 19.2891 8.71429H30.4319C30.9053 8.71429 31.2891 9.09804 31.2891 9.57143C31.2891 10.0448 30.9053 10.4286 30.4319 10.4286H19.2891C18.8157 10.4286 18.4319 10.0448 18.4319 9.57143Z",
    fill: "#0E0F10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2891 23.2857C18.8157 23.2857 18.4319 23.6695 18.4319 24.1429C18.4319 24.6162 18.8157 25 19.2891 25H30.4319C30.9053 25 31.2891 24.6162 31.2891 24.1429C31.2891 23.6695 30.9053 23.2857 30.4319 23.2857H19.2891Z",
    fill: "#0E0F10"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4319 13.8571C18.4319 13.3838 18.8157 13 19.2891 13H26.1462C26.6196 13 27.0033 13.3838 27.0033 13.8571C27.0033 14.3305 26.6196 14.7143 26.1462 14.7143H19.2891C18.8157 14.7143 18.4319 14.3305 18.4319 13.8571Z",
    fill: "#0E0F10"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2891 27.5714C18.8157 27.5714 18.4319 27.9552 18.4319 28.4286C18.4319 28.902 18.8157 29.2857 19.2891 29.2857H26.1462C26.6196 29.2857 27.0033 28.902 27.0033 28.4286C27.0033 27.9552 26.6196 27.5714 26.1462 27.5714H19.2891Z",
    fill: "#0E0F10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointerLogo);
export default __webpack_public_path__ + "static/media/pointer_logo.f937b65aeb4a14d731306e50315c38d1.svg";
export { ForwardRef as ReactComponent };